import moment, { Moment } from "moment-timezone";
import { ClasseAtivo } from "../enum";

interface IDistribuicao {
  classeAtivo: ClasseAtivo;
  data: Moment;
  valorAplicado: number;
  saldoBruto: number;
}

export default class Distribuicao implements IDistribuicao {
  public classeAtivo!: ClasseAtivo;
  public data!: Moment;
  public valorAplicado!: number;
  public saldoBruto!: number;

  constructor(param: IDistribuicao) {
    Object.assign(this, param);
  }

  public static fromJson(json: IDistribuicaoJson) {
    return new Distribuicao({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}

export interface IDistribuicaoJson extends Omit<IDistribuicao, "data"> {
  data: Moment;
}
